import React, {Component} from 'react';
import {Htmldiff} from "../htmldiff";
import BaseComponent from "../../../../base/BaseComponent";
import moment from "moment";
import {removeInfoFromLocalStorage} from "../../../../actions";

class Process extends BaseComponent {

    static defaultProps = {
        dataType: "website"
    };

    state = {
        list : [],
    };

    componentDidMount() {
        let editorId = this.props.id;
        let dataType = this.props.dataType;
        this.getHistoryData(dataType, editorId);
        window.onbeforeunload = ()=>{
            if(window.opener && window.opener.sessionStorage && window.opener.sessionStorage.removeItem) {
                let search = window.location.search;
                if(search){
                    let uuid = search.replace(/.*paramsUUID=([A-Za-z0-9\-_]+).*/, "$1");
                    if(uuid){
                        let attr = "paramsUUID_" + uuid;
                        let prev = window.location.href.replace(/(https?:\/\/[^\/]*).*cm-sites\/([^\/]*).*/, "$1_$2").replace(/[:\/\.]/g, "_");
                        if(prev){
                            attr = prev + "_" + attr;
                            window.opener.sessionStorage.removeItem(attr);
                        }
                    }
                }
            }
            // 这里需要注掉的原因： 页面刷新后数据丢失
            // this.removeParentParams()
        };
    }

    componentWillUnmount() {
    }

    getHistoryData(dataType, editorId){
        if(this.urlParams && this.urlParams.length) {
            let list = this.urlParams.map(item=>{
                if(item) {
                    let createTime = item.createTime ? moment(item.createTime).format('YYYY-MM-DD HH:mm:ss') : null;
                    return {
                        content: item.processData.data.content,
                        operator: item.operatorName,
                        id: item.id,
                        creatTime: item.createTime,
                        title: item.title,
                        type: item.activitiCategoryKey,
                        showName: `${item.operatorName} ${createTime}`,
                    }
                }
                return ""
            });
            this.setState({list})
        }
    }

    render() {
        let props = {
            dataKey: "id",
            dataValue: "showName",
            leftDataSource: this.state.list,
            rightDataSource: this.state.list,
            leftContent: (this.state.list && this.state.list.length > 0 && this.state.list[0].content) ? this.state.list[0].content:"",
            rightContent: (this.state.list && this.state.list.length > 0 && this.state.list[0].content) ? this.state.list[0].content:"",
            leftSelectOnChange:(id)=>{
                return new Promise((resolve, reject) => {
                    let item = this.state.list.find(item=>item.id === id);
                    resolve(item.content);
                })
            },
            rightSelectOnChange:(id)=>{
                return new Promise((resolve, reject) => {
                    let item = this.state.list.find(item=>item.id === id);
                    resolve(item.content);
                })
            }
        };
        console.log("this.state.list",this.state.list)
        return (
            <Htmldiff {...props} />
        );
    }

}

export default Process;